import React, { Fragment } from 'react'
import { PageAddressNavigatorProps } from './PageAddressNavigator.types'
import styles from './PageAddressNavigator.module.scss'
import cl from 'classnames'
import { H1 } from '../H1'
import { IconArrowRight } from 'assets'

const PageAddressNavigatorComponent = (props: PageAddressNavigatorProps) => {
  const {
    segments
  } = props

  return (
    <div className={cl(styles.container)}>
      {segments.map((segment, index) => {
        const {
          component,
          icon: Icon,
          iconProps = {},
          label,
          onClick
        } = segment

        const isLastSegment = index === segments.length - 1

        return (
          <Fragment key={index}>
            {component || (
              <div
                key={index}
                className={cl(styles.segmentContainer, { [styles.clickable]: onClick })}
                onClick={onClick}
              >
                {Icon && (
                  <Icon
                    viewBox='0 0 20 20'
                    width={28}
                    height={28}
                    fill={styles.primary}
                    {...iconProps}
                  />
                )}
                {label && <H1>{label}</H1>}
              </div>
            )}

            {!isLastSegment && (
              <IconArrowRight
                viewBox='0 0 8 12'
                height={14}
                width={9}
                style={{ margin: '0 20px' }}
              />
            )}

          </Fragment>
        )
      })}
    </div>
  )
}

const PageAddressNavigator = PageAddressNavigatorComponent
export { PageAddressNavigator }
